import React, { useEffect } from 'react'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Container, Row, Col, Card, Button, Nav, Table, Badge } from 'react-bootstrap';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend, BarChart, Bar } from 'recharts';
import { Download, Utensils } from 'lucide-react';
import BreakdownItem from '../Components/BreakdownItem/BreakdownItem';
import { fetchOrders } from '../hooks/order';
import { useDispatch, useSelector } from 'react-redux';
import { fetchweeks } from '../hooks/week';
import { fetchProfile } from '../hooks/Profile';
function StudentHomeDashboard() {
    const dayMap = {
    sat: "السبت",
    sun: "الأحد",
    mon: "الاثنين",
    tue: "الثلاثاء",
    wed: "الأربعاء",
    thu: "الخميس",
    fri: "الجمعة",
  };
  const dispatch = useDispatch()
  const { list: weekList } = useSelector((state) => state.week);
  const { list: orders } = useSelector((state) => state.order);
  const today = new Date();
  const currentWeek = weekList.find(week => {
    const start = new Date(week.start_date);
    const end = new Date(week.end_date);

    return today >= start && today <= end;
  });
  const getWeekRange = () => {
    const today = new Date();

    // بداية الأسبوع (السبت أو الأحد حسب اختيارك)
    const firstDay = new Date(today);
    const day = today.getDay(); // 0 = Sunday

    // لو عايز الأسبوع يبدأ من السبت:
    const diffToSaturday = day === 6 ? 0 : -(day + 1);
    firstDay.setDate(today.getDate() + diffToSaturday);

    const lastDay = new Date(firstDay);
    lastDay.setDate(firstDay.getDate() + 6);

    return { firstDay, lastDay };
  }; const formatDateArabic = (date) => {
    return date.toLocaleDateString("ar-EG", {
      day: "numeric",
      month: "long",
    });
  };
  const { firstDay, lastDay } = getWeekRange();
  useEffect(() => {
        dispatch(fetchweeks())
          dispatch(fetchProfile())
        
    
    if (currentWeek?.id) {
      dispatch(fetchOrders(currentWeek.id));
    }
  }, [currentWeek]);
const weeklyData = Object.keys(orders?.days || {}).map((dayKey) => {
  const meals = orders.days[dayKey];

  return {
    day: dayMap[dayKey],
    breakfast: meals.includes(10) ? "true" : "false",
    lunch: meals.includes(11) ? "true" : "false",
    dinner: meals.includes(12) ? "true" : "false",
  };
});
  // const weeklyData = [
  //   { day: 'الاثنين', breakfast: "false", lunch: "true", dinner: "false" },
  //   { day: 'الثلاثاء', breakfast: "false", lunch: "true", dinner: "false" },
  //   { day: 'الأربعاء', breakfast: "false", lunch: "true", dinner: "false" }, // ذروة
  //   { day: 'الخميس', breakfast: "false", lunch: "true", dinner: "false" },
  //   { day: 'الجمعة', breakfast: "false", lunch: "true", dinner: "false" },
  //   { day: 'السبت', breakfast: "false", lunch: "true", dinner: "false" },

  // ];


  const chartData = Object.keys(orders?.days || {}).map((dayKey) => {
    const meals = orders.days[dayKey];
    console.log(meals);

    return {
      day: dayMap[dayKey],
      total: meals.length,
      breakfast: meals.find((item) => item == 10) ? 1 : 0,
      lunch: meals.find((item) => item == 11) ? 1 : 0,
      dinner: meals.find((item) => item == 12) ? 1 : 0,

    };
  });
  // const chartData = weeklyData.map(item => ({
  //   day: item.day,
  //   breakfast: item.breakfast === "true" ? 1 : 0,
  //   lunch: item.lunch === "true" ? 1 : 0,
  //   dinner: item.dinner === "true" ? 1 : 0,
  // }));
  const StatusBadge = ({ status }) => (
    <Badge bg={status === "true" ? "success" : "light"} text={status === "true" ? "white" : "muted"} className="p-2">
      {status === "true" ? "✓" : "✗"}
    </Badge>
  );
  console.log(chartData);
const totalWeekMeals = chartData.reduce((sum, item) => {
  console.log(sum + item.total);

  return sum + item.total;
}, 0);
console.log(totalWeekMeals,"totalWeekMeals");

  return (
    <div>
      <AuthNavbar />
      <Container fluid className="p-4 bg-light" dir="rtl">

        {/* العنوان والفلاتر */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <small className="text-muted text-uppercase">التقارير  الأداء الأسبوعي</small>
            <h4 className="fw-bold">المقاييس المؤسسية</h4>
          </div>
          {/* <Nav variant="pills" defaultActiveKey="all" className="bg-white p-1 rounded-pill shadow-sm">
          <Nav.Item><Nav.Link eventKey="all" className="rounded-pill px-4">الكل</Nav.Link></Nav.Item>
          <Nav.Item><Nav.Link eventKey="breakfast" className="rounded-pill px-4">فطور</Nav.Link></Nav.Item>
          <Nav.Item><Nav.Link eventKey="lunch" className="rounded-pill px-4">غداء</Nav.Link></Nav.Item>
          <Nav.Item><Nav.Link eventKey="dinner" className="rounded-pill px-4">عشاء</Nav.Link></Nav.Item>
        </Nav> */}
        </div>

        <Row className="g-4">
          {/* الرسم البياني للتوزيع الأسبوعي */}
          <Col lg={8}>
            <Card className="border-0 shadow-sm p-4 h-100">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <h5 className="fw-bold mb-0">التوزيع الأسبوعي</h5>
                  <small className="text-muted">
                    إجمالي الحجز للأيام من {formatDateArabic(firstDay)} -{" "}
                    {formatDateArabic(lastDay)}
                  </small>
                </div>
                {/* <Button variant="outline-success" size="sm" className="d-flex align-items-center gap-2">
                <Download size={16} /> تصدير CSV
              </Button> */}
              </div>

              <div style={{ width: '100%', height: 250 }} className="mb-4">
                <ResponsiveContainer>
                  <BarChart data={chartData}>
                    <XAxis dataKey="day" />
                    <YAxis />
                    <Tooltip />

                    <Bar dataKey="total" name="عدد الوجبات" fill="#10b981" stackId="a" />
                    <Bar dataKey="breakfast" name="فطور" stackId="a" fill="#10b981" radius={[0, 0, 0, 0]} />
                    <Bar dataKey="lunch" name="غداء" stackId="a" fill="#059669" radius={[0, 0, 0, 0]} />
                    <Bar dataKey="dinner" name="عشاء" stackId="a" fill="#064e3b" radius={[5, 5, 0, 0]} />

                  </BarChart>
                  {/* <BarChart data={chartData}>
            <XAxis dataKey="day" axisLine={false} tickLine={false} />
            <YAxis domain={[0, 3]} hide /> 
            <Tooltip 
              formatter={(value) => (value === 1 ? "تم التناول" : "لم يتم التناول")}
              contentStyle={{ borderRadius: '10px', textAlign: 'right' }}
            />
            <Legend verticalAlign="top" align="left" />
            
            <Bar dataKey="breakfast" name="فطور" stackId="a" fill="#10b981" radius={[0, 0, 0, 0]} />
            <Bar dataKey="lunch" name="غداء" stackId="a" fill="#059669" radius={[0, 0, 0, 0]} />
            <Bar dataKey="dinner" name="عشاء" stackId="a" fill="#064e3b" radius={[5, 5, 0, 0]} />
          </BarChart> */}
                </ResponsiveContainer>
              </div>
            </Card>
          </Col>

          {/* القسم الجانبي: إجمالي الحجم وتفاصيل الخدمات */}
          <Col lg={4}>
            <div className="d-flex flex-column gap-4">

              {/* بطاقة الحجم الإجمالي */}
              <Card className="border-0 shadow-sm p-4 text-white" style={{ backgroundColor: '#065f46' }}>
                <div className="d-flex align-items-center gap-2 opacity-75 mb-3">
                  <Utensils size={20} />
                  <small className="text-uppercase fw-bold">الحجم الأسبوعي</small>
                </div>
                <div className="d-flex align-items-baseline gap-2">
                  <h1 className="fw-bold mb-0">{totalWeekMeals}</h1>
                  <span>وجبة</span>
                </div>
                {/* <small className="mt-2 text-white-50">↗ 12.4% مقارنة بالأسبوع الماضي</small> */}
              </Card>

              {/* تفاصيل الخدمات (Breakdown) */}
              <Card className="border-0 shadow-sm p-4">
                <h6 className="fw-bold mb-4">تفاصيل الخدمة</h6>

                <Table responsive hover className="text-center align-middle">
                  <thead className="bg-light">
                    <tr>
                      <th>اليوم</th>
                      <th>الفطور</th>
                      <th>الغداء</th>
                      <th>العشاء</th>
                    </tr>
                  </thead>
                  <tbody>
                    {weeklyData.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.day}</td>
                        <td><StatusBadge status={item.breakfast} /></td>
                        <td><StatusBadge status={item.lunch} /></td>
                        <td><StatusBadge status={item.dinner} /></td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default StudentHomeDashboard